export const DEFAULT_LOC = "od";
export const DEFAULT_PINCODE = "752121";
